import {
  getEmployees,
  getEmployee,
  getEmployeeSnapshot,
  removeActiveEmployees,
  removeUploadingEmployees,
  sendInviteEmployees,
  updateEmployeeModel,
  updateEmployeeTaxRegime,
} from "./repository/employees-repository";

const inMemoryCache = { employees: [] };

export const getCacheName = (fields = null) =>
  `employees${fields ? `_${fields}` : ""}`;

export const resetEmployeeCache = () => {
  inMemoryCache.employees = [];
};

export async function findFreshEmployees({ companyId, newFields = null }) {
  const fields = newFields ? newFields.replace(/\s/g, "") : null;
  const params = fields ? { params: { fields } } : null;
  const { data } = await getEmployees({ companyId, params });
  inMemoryCache.employees = data;
  return inMemoryCache.employees;
}

export async function findEmployees(companyId, fields = null) {
  const fieldsFormatted = fields ? fields.replace(/\s/g, "") : null;
  const cacheName = getCacheName(fieldsFormatted);
  if (!inMemoryCache[cacheName] && !inMemoryCache[cacheName].length) {
    const res = await findFreshEmployees({ companyId, newFields: fields });
    return res;
  }

  return inMemoryCache.employees;
}

const defaultFields =
  "id, email, name, surname, state, taxRegime, payrollCompany, costCenter, glossSalary, companyId, legalId, modelId, error, warning, internalId, termsAndConditions, userId, hiringDate, inMigration";

export const findFreshEmployeesWithFields = async (
  companyId,
  fields = defaultFields
) => {
  const res = await findFreshEmployees({ companyId, newFields: fields });
  return res;
};

export const findEmployeesWithFields = async ({
  companyId,
  fields = defaultFields,
}) => {
  const res = await findFreshEmployees({ companyId, newFields: fields });
  return res;
};

export const findEmployeeDetail = async ({ companyId, employeeId }) => {
  const { data } = await getEmployee({ companyId, employeeId });
  const { employee } = data;
  if (inMemoryCache.employees && inMemoryCache.employees.length) {
    const idx = inMemoryCache.employees.findIndex(
      (el) => el.employeeId === employeeId
    );

    if (idx >= 0) inMemoryCache.employees[idx] = employee;
    else inMemoryCache.employees = [...inMemoryCache.employees, employee];
  }
  return employee;
};

export const findEmployeeDetailSnapshot = async ({ companyId, employeeId }) => {
  const { data } = await getEmployeeSnapshot({ companyId, employeeId });
  return data.employee;
};

export async function deleteActiveEmployees({ companyId, payload }) {
  const index = inMemoryCache.employees.findIndex(
    (e) => e.id === payload.employeeId
  );
  if (inMemoryCache?.employees?.[index]?.state) {
    inMemoryCache.employees[index].state = "removed";
  }
  const res = await removeActiveEmployees({ companyId, payload });
  return res;
}

export async function deleteUploadingEmployees({ employeeIds, companyId }) {
  // eslint-disable-next-line
  for (const id of employeeIds) {
    const index = inMemoryCache.employees.findIndex((e) => e.id === id);
    inMemoryCache.employees.splice(index, 1);
  }
  const res = await removeUploadingEmployees({ companyId, employeeIds });
  return res;
}

export async function inviteEmployees({ employees, companyId }) {
  // eslint-disable-next-line
  for (const employee of employees) {
    const index = inMemoryCache.employees.findIndex(
      (e) => e.id === employee.id
    );
    inMemoryCache.employees[index].state = "active";
  }
  const res = await sendInviteEmployees({ employees, companyId });
  return res;
}

export async function updateBenefitModel({ companyId, employeeIds, modelId }) {
  const res = await updateEmployeeModel({ companyId, employeeIds, modelId });
  // eslint-disable-next-line
  for (const id of employeeIds) {
    const index = inMemoryCache.employees.findIndex((e) => e.id === id);
    inMemoryCache.employees[index].modelId = modelId;
  }
  return res;
}

export async function updateTaxRegime({ companyId, employeeIds, taxRegime }) {
  const res = await updateEmployeeTaxRegime({
    companyId,
    employeeIds,
    taxRegime,
  });
  // eslint-disable-next-line
  for (const id of employeeIds) {
    const index = inMemoryCache.employees.findIndex((e) => e.id === id);
    inMemoryCache.employees[index].taxRegime = taxRegime;
  }
  return res;
}
